import { ICaseLawDocument } from "../../caseLawDocuments/model/CaseLawDocument";
import CaseLawDocumentMapper from "../../caseLawDocuments/service/CaseLawDocumentMapper";
import CaseLawDocumentParamMapper from "../../caseLawDocuments/service/CaseLawDocumentParamMapper";
import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../common/Constants";

export default class GetCaseLawDocumentsByIndexInteractor {
  private resource: GetAllResourceEntriesInteractor<ICaseLawDocument>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(organisationId: number, indexId: number) {
    return await this.resource.execute(
      `${Constants.organisationsPath}/${organisationId}/${Constants.indexes}/connected`,
      CaseLawDocumentMapper,
      CaseLawDocumentParamMapper,
      {
        params: { indexId: indexId }
      }
    );
  }
}
